import { loadMember, loadMemberRewards } from '@vista-digital/occ-domain'

export type JobType = 'loyalty-reset-ticketing' | 'loyalty-reset-f&b'
export type TaskMap = { [k in JobType]?: () => void }

export const tasksMap: TaskMap = {
    'loyalty-reset-ticketing': () => {
        void loadMember(true)
        void loadMemberRewards(true)
    },
    'loyalty-reset-f&b': () => {
        void loadMember(true)
        void loadMemberRewards(true)
    },
}
